// 분리된 타입들을 import
import type { TokenInfoRawData, TokenInfoStateData } from './tokenInfo';
import { TokenSource } from './tokenInfo';
import type { RankingRawData, RankingStateData } from './ranking';
import type { StatisticsRawData, StatisticsStateData } from './statistics';
import type { DevClusterRawData, DevClusterStateData } from './devcluster';
import type { FeTokenStateRawData, FeTokenStateStateData } from './feTokenState';
import { TokenCategory, TokenStatus } from './feTokenState';
import { OpinionItemType } from './opinionItemType';
import type { FeTokenAlertRawData, FeTokenAlertStateData, AlertType } from './feTokenAlert';
import type { PriceTrackerRawData, PriceTrackerStateData } from './priceTracker';
import type { DexScreenerRawData, DexScreenerStateData } from './dexScreener';
export { AlertType } from './feTokenAlert';

// Re-export for external use
export type { TokenInfoRawData, RankingRawData, StatisticsRawData, DevClusterRawData, FeTokenStateRawData, FeTokenAlertRawData, FeTokenAlertStateData, PriceTrackerRawData, PriceTrackerStateData, DexScreenerRawData, DexScreenerStateData };
export { TokenSource, TokenCategory, TokenStatus, OpinionItemType };

export enum AFMessageType {
  TOKEN_INFO = 'TOKEN_INFO',
  AF_RANK = 'AF_RANK',
  TOKEN_STATISTICS = 'TOKEN_STATISTICS',
  DEV_CLUSTER_COUNT = 'DEV_CLUSTER_COUNT',
  PRICE_TRACKER = 'PRICE_TRACKER',
  FE_TOKEN_STATE = 'FE_TOKEN_STATE',
  FE_TOKEN_ALERT = 'FE_TOKEN_ALERT',
  DEX_SCREENER = 'DEX_SCREENER',
}

export const AFMessageTypeList = Object.keys(AFMessageType);

export const afMessageTypeToStoreKey = {
  [AFMessageType.TOKEN_INFO]: 'tokenInfo',
  [AFMessageType.AF_RANK]: 'ranking',
  [AFMessageType.TOKEN_STATISTICS]: 'statistics',
  [AFMessageType.DEV_CLUSTER_COUNT]: 'devCluster',
  [AFMessageType.PRICE_TRACKER]: 'priceTracker',
  [AFMessageType.FE_TOKEN_STATE]: 'feTokenState',
  [AFMessageType.FE_TOKEN_ALERT]: 'feTokenAlert',
  [AFMessageType.DEX_SCREENER]: 'dexScreener',
}

export interface AFMessage<T = AFMessageRawData> {
  tokenAddress: string;
  timestamp: number;
  type: AFMessageType;
  data: T;
}

export type AFMessageRawData = TokenInfoRawData | RankingRawData | StatisticsRawData | DevClusterRawData | FeTokenStateRawData | FeTokenAlertRawData | PriceTrackerRawData | DexScreenerRawData
export type AFMessageStateData = TokenInfoStateData | RankingStateData | StatisticsStateData | DevClusterStateData | FeTokenStateStateData | FeTokenAlertStateData | PriceTrackerStateData | DexScreenerStateData


// FE Data State
export interface TokenState {
  tokenAddress: string;
  tokenInfo: TokenInfoStateData;
  ranking: RankingStateData;
  statistics: StatisticsStateData;
  devCluster: DevClusterStateData;
  priceTracker: PriceTrackerStateData;
  dexScreener: DexScreenerStateData;
  feTokenState: FeTokenStateStateData;
  feTokenAlert: Partial<Record<AlertType, FeTokenAlertStateData>>;
  lastUpdated: number;
  hasOrderIssue: boolean;
}

// 전체 토큰 데이터 맵
export interface TokenStateMap {
  [tokenAddress: string]: TokenState;
}

// WebSocket State
export interface WebSocketState {
  isConnected: boolean;
  lastConnected?: number;
  reconnectAttempts: number;
  error?: string;
}

export interface AFDataObject<TRawData extends AFMessageRawData = AFMessageRawData, TStateData extends AFMessageStateData = AFMessageStateData> {
  toRawData: () => TRawData;
  getMessageType: () => AFMessageType;
  toStateData: () => TStateData;
  filter: (oldData: TStateData) => boolean;
}